export default class Modal {
    constructor(title = '', content = '') {
        this.title = title;
        this.content = content;

        this.create();
    }

    create() {
        this.destroy();

        const dialog = document.createElement('dialog');
        dialog.className = 'site-modal';

        const content = document.createElement('div');
        content.className = 'site-modal__content';

        const closeButton = document.createElement('button');
        closeButton.type = 'button';
        closeButton.className = 'site-modal__close';
        closeButton.setAttribute('aria-label', 'Close');
        closeButton.textContent = '×';

        const titleElement = document.createElement('h2');
        titleElement.className = 'site-modal__title';
        titleElement.textContent = this.title;

        const bodyElement = document.createElement('div');
        bodyElement.className = 'site-modal__body';
        bodyElement.textContent = this.content;

        content.appendChild(closeButton);
        content.appendChild(titleElement);
        content.appendChild(bodyElement);

        dialog.appendChild(content);
        document.body.appendChild(dialog);

        this.dialog = dialog;

        closeButton.addEventListener('click', () => {
            this.close();
        });

        dialog.addEventListener('click', (event) => {
            if (event.target === dialog) {
                this.close();
            }
        });

        dialog.addEventListener('cancel', (event) => {
            event.preventDefault();
            this.close();
        });

        dialog.showModal();
    }

    close() {
        if (!this.dialog) {
            return;
        }

        this.dialog.close();
        this.dialog.remove();
        this.dialog = null;
    }

    destroy() {
        const existingModal = document.querySelector('.site-modal');

        if (existingModal) {
            if (existingModal.open) {
                existingModal.close();
            }

            existingModal.remove();
        }
    }
}